<template>
  <bimPopup
    :title="title"
    :value="value"
    @input="close"
    class="bim-popover popover"
    hideCloseButton
  >
    <div class="menu" :style="{ 'max-height': maxHeight }">
      <div
        v-for="(item, index) of menu"
        :key="index"
        :class="{ delimiter: item.delimiter, disabled: item.disabled }"
        class="menu-item"
      >
        <bim-checkbox
          v-if="item.type === 'checkbox'"
          @click.stop
          @input="value => {
            if (item.value !== value) item.callback && item.callback()
          }"
          :label="item.title"
          :value="item.value"
          :id="item.title"
        />
        <bim-radio
          v-if="item.type === 'radio'"
          @click.stop
          @input="() => { item.callback && item.callback() }"
          :label="item.title"
          :value="item.value"
          :val="item.val"
          :id="item.title"
          :name="item.title"
        />
        <div @click.stop="($event) => { item.callback && item.callback($event) }" class="menu-item__content">
          <div v-if="item.icon && typeof item.icon === 'object'" class="menu-icon" v-html="item.icon"></div>
          <img v-if="item.icon && typeof item.icon === 'string'" class="menu-icon" :src="item.icon" alt />
          <div v-if="item.title && !item.type" class="menu-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </bimPopup>
</template>

<script>
import bimPopup from '@/components/ui/bimPopup/bimPopup'
import bimCheckbox from '@/components/form/bimCheckbox/bimCheckbox.vue'
import bimRadio from '@/components/form/bimRadio/bimRadio.vue'

export default {
  name: 'bimPopover',
  components: {
    bimPopup,
    bimCheckbox,
    bimRadio
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    value: Boolean,
    menu: {
      type: Array,
      default: () => ([]),
      prop: {
        icon: Object,
        title: String,
        callback: Function,
        type: String,
        value: null,
        delimiter: Boolean,
        disabled: Boolean
      }
    },
    maxHeight: {
      type: String,
      default: 'auto'
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.close = this.close.bind(this)
    window.addEventListener('click', this.close)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.close)
  },
  computed: {},
  methods: {
    close () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.bim-popover.popover {
  position: absolute;
  top: 0;
  left: 0;
  right: inherit;
  bottom: inherit;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.15);
  background: none;
  border-radius: 9px;
  width: 199px;

  ::v-deep {
    .modal-content {
      padding: 10px 0 6px;
      width: 100%;
    }
    .modal-body {
      padding: 0;
    }
    .modal-header {
      padding: 0 14px 4px;
    }
    .modal-title {
      font-size: 8px;
      line-height: 1.88;
      letter-spacing: 0.8px;
      opacity: .5;
      text-transform: uppercase;
    }
  }

  .menu {
    overflow: auto;

    .menu-item.delimiter {
      margin: 4px 0;
      padding: 0;
      height: 1px;
      background: rgba(0,0,0,.1);
    }

    .menu-item {
      margin: 0 4px 2px;
      display: flex;
      align-items: center;
      padding: 7px 8px;
      transition: all .2s;
      cursor: pointer;
      border-radius: 2px;
      position: relative;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }

      &:active {
        background-color: rgba(0, 0, 0, 0.02);
      }

      &.disabled {
        cursor: auto;
        pointer-events: none;
        background-color: rgba(0, 0, 0, 0.02);
      }
    }

    .menu-item__content {
      display: flex;
    }

    .menu-item__content::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .menu-title {
      position: relative;
      top: -1px;
      font-size: 12px;
      line-height: 1.83;
      letter-spacing: 0.5px;
      font-family: Helvetica, sans-serif;
      padding-left: 6px;
    }

    .menu-icon, .menu-icon ::v-deep svg {
      width: 16px !important;
      height: 16px !important;
    }
  }
}
</style>
